import { Component, Input, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TslPage } from 'projects/aztalena-core/src/public-api';
import { defaultTheme } from 'src/app/theme/theme';
import { Topic } from '../../forum/topic';
import { UserService } from '../user.service';

@Component({
  selector: 'app-user-topics',
  templateUrl: './user-topics.component.html',
  styleUrls: ['./user-topics.component.scss'],
  standalone: false
})
export class UserTopicsComponent implements OnInit {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private userService = inject(UserService);

  @Input()
  theme = defaultTheme;

  username: string;
  isLoading = true;
  userTopics: Topic[] = [];
  page: TslPage = {
    number: 0,
    size: 10
  };

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.isLoading = true;
      this.username = params['username'];
      this.userService.getTopics(this.username, this.page.number).subscribe({
        next: (page) => {
          this.userTopics = page.items;
          this.page = page.page;
          this.isLoading = false;
        },
        error: () => {
          this.isLoading = false;
        }
      });
    });
  }

  changePage(pageNumber: number): void {
    this.userService.getTopics(this.username, pageNumber, this.page.size).subscribe((page) => {
      this.userTopics = page.items;
      this.page = page.page;
      this.router.navigate([], {
        queryParams: { page: this.page.number },
        queryParamsHandling: 'merge'
      });
    });
  }
}
